<div class="spacer">
  <p-panel>
    <div class="grid">
      <div class="col-12">
        <p-header class="sub-section-header">APR Fiscal Years</p-header>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Fiscal Year:
            <span class="required">*</span>
          </span>
          <p-select class="is-dropdown" placeholder=" " [options]="fiscalYears" name="fiscalYears"
            [(ngModel)]="fiscalYear" [dropdownIcon]="'fa fa-chevron-down'" (onChange)="onChange($event)">
          </p-select>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-start" *ngIf="!this.addYearClicked">
          <button name="Add Year" pButton type="button" label="Add Year" (click)="addFiscalYear()"
            class="button small primary p-button-rounded">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="this.fiscalYear !== undefined && !this.copyYearClicked">
        <div class="content-start">
          <button name="Copy Year" pButton type="button" label="Copy Year" (click)="copyFiscalYear()"
            class="button small-green">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="this.fiscalYear !== undefined && !this.addDomicileClicked">
        <div class="content-start">
          <button name="Add Domicile" pButton type="button" label="Add Domicile" (click)="addDomicile()"
            class="button small">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3"></div>
    </div>

    <div class="grid" *ngIf="this.copyYearClicked">
      <div class="col-12">
        <p-header class="sub-section-header">Copy Fiscal Year</p-header>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            New Fiscal Year:
            <span class="required">*</span>
          </span>
          <input id="newFiscalYear" type="text" class="is-input" name="Copy Fiscal Year" pInputText
            [(ngModel)]="newFiscalYear" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-start">
          <button name="Copy Fiscal Year" pButton type="button" label="Copy Year" (click)="copyExistingFiscalYear()"
            class="button primary p-button-rounded">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-start">
          <button name="Cancel" pButton type="button" label="Cancel" (click)="cancelCopy()" class="button default">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-5"></div>
    </div>

    <div class="grid" *ngIf="this.addYearClicked">
      <div class="col-12">
        <p-header class="sub-section-header">Add Fiscal Year</p-header>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Fiscal Year:
            <span class="required">*</span>
          </span>
          <input id="inpFiscalYear" type="text" class="is-input" name="Fiscal Year" pInputText
            [(ngModel)]="inpFiscalYear" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-start">
          <button name="Add Fiscal Year" pButton type="button" label="Add Year" (click)="addFiscalToTable()"
            class="button primary p-button-rounded">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-start">
          <button name="Cancel" pButton type="button" label="Cancel" (click)="cancelAddYear()" class="button default">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-5"></div>
    </div>

    <div class="grid" *ngIf="this.addDomicileClicked">
      <div class="col-12">
        <p-header class="sub-section-header">Add Domicile</p-header>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Domicile:
            <span class="required">*</span>
          </span>
          <input id="domicile" type="text" class="is-input" name="domicile" pInputText [(ngModel)]="domicile" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="stacked-content">
          <span class="content-label">
            OTR:
            <span class="required">*</span>
          </span>
          <input id="otr" type="text" class="is-input" name="otr" pInputText [(ngModel)]="otr" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="stacked-content">
          <span class="content-label">
            Handling:
            <span class="required">*</span>
          </span>
          <input id="handling" type="text" class="is-input" name="handling" pInputText [(ngModel)]="handling" />
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="content-end">
          <button name="Cost Domicile" pButton type="button" label="Add Domicile" (click)="addDomicileToMaster()"
            class="button primary p-button-rounded">
          </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <div class="content-end">
          <button name="Cancel" pButton type="button" label="Cancel" (click)="cancelAddDomicile()"
            class="button default">
          </button>
        </div>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-12"></div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-2"></div>
      <div class="col-12 md:col-6 lg:col-8">
        <div *ngFor="let msg of errMsgs">
          <p-message [severity]="msg.severity" [text]="msg.summary" [closable]="true"></p-message>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2"></div>
    </div> 
    <div class="grid">
      <div class="col-12" *ngIf="this.existingAPRCosts?.length > 0">
        <p-header class="sub-section-header">Existing APR Rates for the Fiscal Year - {{fiscalYear}}</p-header>
      </div>
      <div class="newtable">
        <p-table *ngIf="this.existingAPRCosts?.length > 0" #aprCost name="APRCostsTable" scrollHeight="450px"
          [value]="existingAPRCosts" [columns]="aprCostsCols" [scrollable]="true" [resizableColumns]="true"
          sortMode="multiple" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 30, 40, 50]"
          class="data-table shrink-headers">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                  ariaLabelDesc="Activate to sort in descending order"
                  ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
                {{ col.header }}
              </th>
            </tr>
            <tr class="column-filters">
              <th *ngFor="let col of columns" [ngSwitch]="col.field">
                <input *ngIf="col.field != Select" pInputText type="text"
                  (input)="aprCost.filter($event.target.value, col.field, 'contains')"
                  (change)='filterCapture($event, aprCost)'>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-aprCost>
            <tr>
              <td>
                <p-checkbox #chkEnable name="cAprCost" [value]="aprCost" [(ngModel)]="aprCostSelectedValues">
                </p-checkbox>
              </td>
              <td>{{ aprCost.domicile }}</td>
              <td>
                <input size="8" type="text" pInputText [(ngModel)]="aprCost.overTheRoad"
                  [disabled]="!chkEnable.checked">
              </td>
              <td>
                <input size="8" type="text" pInputText [(ngModel)]="aprCost.handlingCharge"
                  [disabled]="!chkEnable.checked">
              </td>
              <td>{{ aprCost.createdBy }}</td>
              <td>{{ convertDateFormat(aprCost.createdDate) }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </div>
    <div class="grid">
      <div *ngIf="this.aprCostSelectedValues?.length > 0" class="col-12 md:col-6 lg:col-6">
        <div class="content-start">
          <button name="Update Selected" pButton type="button" label="Update Selected" (click)="upateAPRCosts()"
            class="button primary p-button-rounded"></button>
        </div>
      </div>
      <div *ngIf="this.aprCostSelectedValues?.length > 0" class="col-12 md:col-6 lg:col-6">
        <div class="content-end">
          <button name="Delete Selected" pButton type="button" label="Delete Selected" (click)="deleteAPRCosts()"
            class="button primary p-button-rounded"></button>
        </div>
      </div>
    </div>

  </p-panel>
</div>